export const LOCATION_STATES = Object.freeze({
  CHECKING: "checking", GRANTED: "granted", PROMPT: "prompt", DENIED: "denied",
  UNAVAILABLE: "unavailable", INSECURE: "insecure", ERROR: "error",
});

export const LOCATION_OPTIONS = Object.freeze({ enableHighAccuracy: true, timeout: 12000, maximumAge: 300000 });
export const LOCATION_FRESHNESS = Object.freeze({ recommendation: 300000, navigate: 60000, register: 300000, default: 300000 });

export const isLocationFresh = (obtainedAt, feature = "default", now = Date.now()) =>
  !!obtainedAt && now - obtainedAt <= (LOCATION_FRESHNESS[feature] || LOCATION_FRESHNESS.default);

export const hasUsableLocation = (state, feature = "default", now = Date.now()) =>
  state?.permissionState === LOCATION_STATES.GRANTED && Number.isFinite(state?.coordinates?.latitude) && Number.isFinite(state?.coordinates?.longitude);

export const publicPosition = position => ({
  coords: {
    latitude: Number(position.coords.latitude),
    longitude: Number(position.coords.longitude),
    accuracy: Number(position.coords.accuracy) || null,
  },
  timestamp: Number(position.timestamp) || Date.now(),
});
